import React, { useEffect, useState } from "react";
import styled from "styled-components";

const formatUtc = (now: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");

  return (
    `${pad(now.getUTCDate())}-${pad(now.getUTCMonth() + 1)}-${now.getUTCFullYear()} ` +
    `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}`
  );
};

const CurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(() => formatUtc(new Date()));

  useEffect(() => {
    const intervalId = setInterval(() => setCurrentTime(formatUtc(new Date())), 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Wrap>
      <Label>BO DT:</Label>
      {currentTime}
      <Label>UTC</Label>
    </Wrap>
  );
};

export default CurrentTime;

// Matches CRM's components/currentTime/CurrentTime.tsx verbatim.
const Wrap = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.fg.secondary};
  ${({ theme }) => theme.typography.body2};
  gap: 3px;
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.fg.accent};
`;
